import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';

const HomePage = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homepage">
      <SEO 
        title="Savi Investing Private Limited - Value Investors in Equities"
        description="Savi Investing is an investing firm that preaches and practices disciplined, value-driven investing. Based in India, we operate actively in the Indian capital markets."
      />
      <Header />
      <Hero />
      <About />
      <Footer />
    </div>
  );
};

export default HomePage;
